import { sendToApi } from 'api/client'

export interface CreditUsage {
  base_credits_available: number
  content_credits_used: number
  video_credits_used: number
  ads_credits_used: number
  visual_styles_credits_used: number
  subscription_id: string | null
  total_credits_available: number
  total_credits_used: number
  credits_remaining: number
  credits_exceeded: boolean
  start_date: string | null // ISO date string (YYYY-MM-DD)
  end_date: string | null // ISO date string (YYYY-MM-DD)
  initial_credits_available: number
  usage_costs: {
    content_credits_cost: number
    video_credits_cost: number
    ads_credits_cost: number
    visual_styles_credits_cost: number
  }
}

export const CreditUsageClient = {
  getCreditUsage: (workspaceId: number) => {
    return sendToApi<{ credit_usage: any }>(`/w/${workspaceId}/credit_usage`, {
      method: 'GET',
    })
  },
}
